<script lang="ts">
    import { ServiceConsts } from "$/services/ServiceConsts";
    import { formattedDateAndTime, fromNow } from "$/utils/date";
    import { tooltip } from "$/utils/tooltip";
    import { url } from "@roxi/routify";

    export let topic: any;
</script>

<div class="inner-card-wrapper">
    <div class="card">
        <div class="card-content">
            <div class="topic-title">{topic.name}</div>
            {#if topic.description}
                <div class="topic-description">{topic.description}</div>
            {/if}
            <div class="topic-info">
                <span
                    use:tooltip={topic.createdBy?.firstName +
                        " " +
                        topic.createdBy?.lastName +
                        " - " +
                        formattedDateAndTime(topic.createdOn)}
                >
                    <!-- HACK: The createdBy should never be null this is done just so null isn't shown instead of user's name -->
                    {topic.createdBy?.firstName || topic.createdBy?.lastName
                        ? `${topic.createdBy.firstName} ${topic.createdBy.lastName} -`
                        : ""}
                    {fromNow(topic.createdOn)}
                </span>
            </div>
        </div>

        <div class="card-footer">
            <a
                class="btn right"
                href={topic.isExample
                    ? ServiceConsts.LOAD_URL + topic.id
                    : $url("/:topicId", { topicId: topic.id })}
                target={topic.isExample ? "_blank" : ""}
            >
                {topic.isExample ? "Explore" : "Open"}
            </a>
        </div>
    </div>
</div>

<style>
    .inner-card-wrapper {
        @apply relative !important;
    }

    .card {
        @apply reset z-50 flex select-text flex-col rounded-b-xl p-0 !important;
    }

    .card-content {
        @apply z-10 flex flex-col justify-between rounded-t-xl border-l border-r border-t border-solid border-gray-200 bg-gray-100 p-4 pb-1 !important;
    }

    .card-footer {
        @apply m-0 flex select-none items-end rounded-b-xl border-[1px] border-solid border-gray-200 bg-white px-2 py-1 !important;
    }

    .topic-title {
        @apply mb-2 break-words font-bold;
    }

    .topic-info {
        @apply ml-auto mt-2 text-xs;
    }

    .topic-info span {
        @apply text-xs text-gray-500;
    }

    .topic-action {
        @apply ml-auto p-1 text-sm;
    }

    .btn {
        @apply rounded border-none px-2 py-1 text-xs font-normal text-black no-underline hover:bg-gray-200 focus:outline-none;
    }

    .btn.right {
        @apply ml-auto;
    }

    .topic-description {
        @apply line-clamp-6 text-sm;
    }
</style>
